/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import {ModelBase} from "./model-base";
import {IModelBase} from "./i-model-base";

export class ConfigurationNl extends ModelBase implements IModelBase {
  locations: string[] = [];
  tagOverrides: string[] = [];
  compositionOverrides: string[] = [];
}
